import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { 
    Table, 
    TableBody, 
    TableCell, 
    TableContainer,
    TableHead, 
    TableRow, 
    Paper 
} from '@mui/material';
import { 
    IconButton,
    Tooltip
} from "@mui/material";
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import DownloadIcon from '@mui/icons-material/Download';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import TracksPlayPauseButton from '../tracks-play-pause/tracks-play-pause';
import { cleanTrackName } from '../../utils/utils';
import { setLoginVisible } from '../../features/dialogControl/dialogControlSlice';
import './track-list.css';
import { useTheme } from '@mui/material/styles';


const TrackList = ({trackList}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const theme = useTheme();
	const currentTrack = useSelector(state => state.audioPlayer.currentTrack);

    const handleLicenseActionClick = () => {
        dispatch(setLoginVisible(true));
    };

    const handleTrackClick = async (track) => {
		navigate(`/track/${track.id}`);
    };

    const handleArtistClick = async (artist) => {
        navigate(`/artist/${artist.id}`);
    };


    return (
        <TableContainer 
            component={Paper} 
            sx={{ 
                marginBottom: '90px',
                backgroundColor: '#121212',
                height: 'unset', 
                overflow: 'visible', 
            }}
            >
            <Table 
                stickyHeader
                sx={{
                    height: 'unset',
                    overflow: 'visible',
                }}              
            >
                <TableHead 
                    sx={{
                        zIndex: 2,
                        boxShadow: '0px 4px 6px -2px rgba(0, 0, 0, 0.1)',
                    }}
                >
                    <TableRow >
                        <TableCell sx={{
                            fontWeight : 'bold',
                            fontSize: '12px',
                            color: theme.palette.contentCopy
                        }}>TRACK</TableCell>
                        <TableCell sx={{
                            fontWeight : 'bold',
                            fontSize: '12px',
                            color: theme.palette.contentCopy,
                            display: { 
                                xs: 'none',
                                sm: 'table-cell',
                                md: 'table-cell'
                            }
                        }}>ARTIST</TableCell>
                        <TableCell
                            sx={{
                            fontWeight : 'bold',
                            fontSize: '12px',
                            color: theme.palette.contentCopy,
                            display: { 
                                xs: 'none',
                                md: 'table-cell'
                            }
                        }}>GENRE</TableCell>
                        <TableCell
                            sx={{
                            fontWeight : 'bold',
                            fontSize: '12px',
                            color: theme.palette.contentCopy,
                            display: { 
                                xs: 'none',
                                md: 'table-cell'
                            }
                        }}>BPM</TableCell>
                        <TableCell 
                            sx={{
                            fontWeight : 'bold',
                            fontSize: '12px',
                            color: theme.palette.contentCopy,
                            display: { 
                                xs: 'none',
                                md: 'table-cell'
                            }
                        }}>LENGTH</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {trackList.map((t, index) => (
                        <TableRow 
                            key={index} 
                            className={`track-list-row ${t.id === currentTrack.id ? 'track-list-row-selected' : ''}`}
                        >
                            <TableCell>
                                <div className='track-controls-container'>
                                    <div className='track-lead-block'>
                                        <TracksPlayPauseButton track={t} playlist={trackList}/>
                                        <div className='track-list-link' 
                                            onClick={() => handleTrackClick(t)}
                                        >
                                            {cleanTrackName(t.title)}
                                        </div>
                                    </div>
                                    <div className='track-access-controls'>
                                        <Tooltip title="Add to favorites" arrow> 
                                            <IconButton 
                                                className="icon-button"
                                                onClick={() => handleLicenseActionClick()}
                                            >
                                                <FavoriteBorderIcon className='icon' />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Download" arrow> 
                                            <IconButton 
                                                className="icon-button"
                                                onClick={() => handleLicenseActionClick()}
                                            >
                                                <DownloadIcon className='icon' />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="License" arrow> 
                                            <IconButton 
                                                className="icon-button"
                                                onClick={() => handleLicenseActionClick()}
                                            >
                                                <CardMembershipIcon className='icon'/>
                                            </IconButton>
                                        </Tooltip>
                                    </div>
                                </div>
                            </TableCell>
                            <TableCell
                                sx={{
                                    display: { 
                                        xs: 'none',
                                        sm: 'table-cell',
                                        md: 'table-cell'
                                    }
                                }}
                            >
                                <div className='track-list-link' 
                                    onClick={() => handleArtistClick(t.artist)}
                                >
                                    {t.artist.artist_name}
                                </div>
                            </TableCell>
                            <TableCell 
                                sx={{
                                    display: { 
                                        xs: 'none',
                                        md: 'table-cell'
                                    }
                                }}
                            ><span className='track-list-item'>{t.genre}</span></TableCell>
                            <TableCell 
                                sx={{
                                    display: { 
                                        xs: 'none',
                                        md: 'table-cell'
                                    }
                                }}
                            ><span className='track-list-item'>{t.bpm}</span></TableCell>
                            <TableCell 
                                sx={{
                                    display: { 
                                        xs: 'none',
                                        md: 'table-cell'
                                    }
                                }}
                            ><span className='track-list-item'>{t.duration}</span></TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default TrackList;